export const uriSafeBase64Encode = (str: string): string => encodeURIComponent(window.btoa(str));

export const uriSafeBase64Decode = (str: string): string => window.atob(decodeURIComponent(str));
